import { FeedbackBanner } from "@/core/components/feedback-banner";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import type { IPayrollSheetApprovalAccessKey } from "@/payroll/payroll.d";

const NAMED_LIMIT = 6;

export const summarizeMissingApprovalNames = (
  accessKeys: IPayrollSheetApprovalAccessKey[],
) => {
  const names = accessKeys.map((accessKey) => accessKey.name);
  if (names.length <= NAMED_LIMIT) return names.join(", ");

  return `${names.slice(0, NAMED_LIMIT).join(", ")} and ${names.length - NAMED_LIMIT} more`;
};

export const getMissingApprovalHeadline = (
  accessKeys: IPayrollSheetApprovalAccessKey[],
) =>
  accessKeys.length === 1
    ? `${accessKeys[0].name} is not ready for PayPacks`
    : `${accessKeys.length} groups of sheets are not ready for PayPacks`;

/**
 * Concise context for a deliberately soft gate. Names enough outstanding units
 * to orient the sender without turning the send confirmation into an audit view.
 */
export const MissingTechApprovalWarning = ({
  accessKeys,
}: {
  accessKeys: IPayrollSheetApprovalAccessKey[];
}) => (
  <FeedbackBanner variant="warning" className="w-full">
    <Stack gap="xs" align="stretch" fullWidth className="min-w-0">
      <Typography variant="bodyW3" className="font-semibold">
        {getMissingApprovalHeadline(accessKeys)}
      </Typography>
      <Typography variant="captionW1" textColor="secondary">
        {accessKeys.length > 1 &&
          `${summarizeMissingApprovalNames(accessKeys)}. `}
        PayPacks will still go out to everyone selected.
      </Typography>
    </Stack>
  </FeedbackBanner>
);
